import { debounce } from "lodash";
import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";

interface MxListObservableChangeProps {
  handleOnChangeFilter: (values: any) => void;
}
const MxListObservableChange = (props: MxListObservableChangeProps) => {
  const { subscribe } = useFormContext();
  const debouncedValues = useMemo(
    () =>
      debounce(values => {
        props.handleOnChangeFilter(values);
      }, 300),
    [props.handleOnChangeFilter]
  );

  useEffect(() => {
    const callback = subscribe({
      formState: {
        values: true
      },
      callback: ({ values }) => {
        debouncedValues(values);
      }
    });

    return () => {
      callback();
      debouncedValues.cancel();
    };
  }, [debouncedValues, subscribe]);
  return null;
};

export default MxListObservableChange;
